import * as React from 'react'
import './style.scss'
import Logo from '../../Quarks/Logo';

const Footer = (props) => (
    <div className="Footer">
        <div className="Content">
            <div className="Logo">
                <Logo />
                <p className="Moto">
                    Создаем контент, нацеленный<br/>на длительную актульность
                </p>
            </div>
            <div className="FooterContent">
                <div className="Column">
                    <p className="Header">Style Guide</p>
                    <a className="Link" href="/justy/colors.html">Colors</a>
                    <a className="Link" href="/justy/home.html">Home</a>
                    <a className="Link" href="/justy/images.html">Images</a>
                    <a className="Link" href="/justy/typography.html">Typography</a>
                    <a className="Link" href="/justy/logo.html">Logo</a>
                </div>
                <div className="Column">
                    <p className="Header">Статьи</p>
                    <a className="Link" href="/justy?target=des">Дизайн</a>
                    <a className="Link" href="/justy?target=code">Код</a>
                    <a className="Link" href="/justy?target=insp">Вдохновение</a>
                </div>
            </div>
        </div>
        <p className="Rights">
            Brand Guideline<br/>©All rights reserved
        </p>
    </div>
)

export default Footer;